import cloneDeep from "lodash.clonedeep";
import cardTypes from "../../constants/cardTypes";

const actions = {
    GET_CARDS : "app/cards/GET_CARDS",
    RESET_CARDS_FILTER : "app/cards/RESET_FILTER",
    ADD_CARD : "app/cards/ADD_CARD",
    EDIT_CARD : "app/cards/EDIT_CARD",
    REMOVE_CARD : "app/cards/REMOVE_CARD"
};

const initialState = {
    cards: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            cardNumberInternal: "",
            userName: ""
        },
        sortFilter: {}
    }
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
    case actions.GET_CARDS:
    {
        return {
            ...state,
            cards: action.payload.cards,
            filter: action.payload.filter
        };
    }
    case actions.RESET_CARDS_FILTER: {
        const newState = cloneDeep(state);
        let modelFilter = cloneDeep(initialState.filter.modelFilter);
        if(action.payload) {
            modelFilter = {...modelFilter, ...action.payload};
        }
        newState.filter.modelFilter = modelFilter;
        return newState;
    }
    case actions.ADD_CARD:
    {
        return {
            ...state,
            cards: [ ...state.cards, action.card ]
        };
    }
    case actions.EDIT_CARD:
    {
        return {
            ...state,
            cards: state.cards.map((item, index) => {
                if (item.cardId !== action.card.cardId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            })
        };
    }
    case actions.REMOVE_CARD:
    {
        const cards = [...state.cards];
        return {
            ...state,
            cards: cards.filter((item, index) => {
                return item.cardId !== action.card.cardId;
            })
        };
    }
    default:
        return state;
    }
};

export const setCards = (cards, filter) => ({type: actions.GET_CARDS, payload: {cards, filter}});
export const resetCardsFilter = (modelFilter) => ({type: actions.RESET_CARDS_FILTER, payload: modelFilter})
export const addCard = (card) => ({type: actions.ADD_CARD, card});
export const editCard = (card) => ({type: actions.EDIT_CARD, card});
export const removeCard = (card) => ({type: actions.REMOVE_CARD, card});
